module.exports = __webpack_public_path__ + "static/media/spoonerism-task (19).755111f5.mp3";